// src/pages/StripePayment.jsx

import React, { useState } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import {
  Elements,
  CardElement,
  useStripe,
  useElements,
} from '@stripe/react-stripe-js';
import api from '../utils/api';

const stripePromise = loadStripe('pk_test_51TLmejLH85ZfpbbxfqJepk9x7POGmddBYvF4XR8unMiNyyQ77jiueFdwgWWQ6YDulvhuz7erYWbZPivoE8TVQnLL008dgzsgzx');

function CheckoutForm({ amount, onSuccess }) {
  const stripe = useStripe();
  const elements = useElements();

  const [error, setError] = useState(null);
  const [processing, setProcessing] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!stripe || !elements) return;

    setProcessing(true);
    setError(null);

    try {
      // 🔥 Convert to cents
      const amountInCents = Math.round(amount * 100);

      // ✅ Create payment intent
      const res = await api.post('/api/stripe/payment-intent', {
        amount: amountInCents,
        currency: 'usd',
      });

      const clientSecret = res.data.clientSecret;

      // ✅ Confirm payment
      const cardElement = elements.getElement(CardElement);

      const result = await stripe.confirmCardPayment(clientSecret, {
        payment_method: {
          card: cardElement,
        },
      });

      if (result.error) {
        setError(result.error.message);
      } else if (result.paymentIntent.status === 'succeeded') {
        onSuccess(result.paymentIntent);
      }

    } catch (err) {
      console.error('Payment Error:', err);
      setError('Payment failed. Please try again.');
    }

    setProcessing(false);
  };

  return (
    <form onSubmit={handleSubmit} className="max-w-md mx-auto p-4 shadow rounded bg-white">
      <h2 className="text-2xl font-bold mb-4">Pay with Card</h2>

      <p className="mb-2">
        Amount: <strong>${amount.toFixed(2)}</strong>
      </p>

      <CardElement className="border p-2 mb-3 rounded" />

      <button
        type="submit"
        disabled={!stripe || processing}
        className="bg-green-600 text-white py-2 px-4 rounded hover:bg-green-700"
      >
        {processing ? 'Processing...' : 'Pay'}
      </button>

      {error && <p className="text-red-600 mt-2">{error}</p>}
    </form>
  );
}

export default function StripePayment({ amount, onSuccess }) {
  return (
    <Elements stripe={stripePromise}>
      <CheckoutForm amount={amount} onSuccess={onSuccess} />
    </Elements>
  );
}
